import { ITagKeys } from '@conexasaude/conexa-hero'
import { UpcomingConsultationData } from '../MyCalls/mappers/UpcomingConsultationMapper.types'

export enum CareModals {
  'Overview' = 'Overview',
  'Create' = 'Create',
  'AfterSchedule' = 'AfterSchedule',
  'Fakedoor' = 'Fakedoor',
  'PauseReminder' = 'PauseReminder',
}

export enum CareTrackers {
  'DeixarParaDepois' = 'Pac_Cuidados_DeixarParaDepois',
  'AgendarConsulta' = 'Pac_Cuidados_AgendarConsulta',
  'AdicionarLembrete' = 'Pac_Cuidados_FKDAdicionarLembrete',
  'RegistrarExame' = 'Pac_Cuidados_FKDRegistrarExame',
  'AcompanharCuidados' = 'Pac_Cuidados_Acompanhar',
  'VoltarParaInicio' = 'Pac_Cuidados_VoltarParaInicio',
  'AcompanharCuidadosSuaSaude' = 'Pac_SuaSaude_AcompanharCuidados',
  'AgendarCuidadoTelaSemHistorico' = 'Pac_Cuidados_Agendar_Tela_SemHistorico',
  'CuidadosAbaProximos' = 'Pac_Cuidados_Aba_Proximos',
  'CuidadosAbaConcluidos' = 'Pac_Cuidados_Aba_Concluidos',
  'VerDetalhesCuidado' = 'Pac_Cuidados_CliqueCardDetalhes',
  'CuidadosCliqueNovoCuidado' = 'Pac_Cuidados_CliqueNovo',
  'CuidadosFiltroBuscarClique' = 'Pac_Cuidados_FiltroBuscarClique',
  'CuidadosErro' = 'Pac_Cuidados_Erro',
  'CuidadosDetalhesAgendarConsulta' = 'Pac_Cuidados_DetalhesAgendarConsulta',
  'CuidadosDetalhesVerConsulta' = 'Pac_Cuidados_DetalhesVerConsulta',
  'CuidadosDetalhesConfirmarConsulta' = 'Pac_Cuidados_DetalhesConfirmarConsulta',
  'CuidadosAlterarStatusSucesso' = 'Pac_Cuidados_AlterarStatusSucesso',
  'CuidadosAlterarStatusErro' = 'Pac_Cuidados_AlterarStatusErro',
  'CuidadosDetalhesCancelarConsulta' = 'Pac_Cuidados_DetalhesCancelarConsulta',
  'CuidadosDetalhesVerAnexos' = 'Pac_Cuidados_DetalhesVerAnexos',
  'CuidadosDetalhesReagendarConsulta' = 'Pac_Cuidados_DetalhesReagendarConsulta',
  'CuidadosDetalhesAcessarConsulta' = 'Pac_Cuidados_DetalhesAcessarConsulta',
  'CareFakedoorModalNotifyUserYes' = 'Pac_Cuidados_FDKNotificacaoSim',
  'CareFakedoorModalNotifyUserNo' = 'Pac_Cuidados_FDKNotificacaoNao',
  'CareFakedoorModalFeedbackYes' = 'Pac_Cuidados_FDKFeedbackEnviar',
  'CareFakedoorModalFeedbackNo' = 'Pac_Cuidados_FDKFeedbackFechar',
  'CareFakedoorModalFinish' = 'Pac_Cuidados_FKDFinalizar',
}

export enum CareEndpoints {
  'HealthCare' = '/integration/lina/health-care',
  'GetCareFeatureFlag' = '/feature-flag/LINA_BANNER',
  'GetCareList' = '/integration/lina/commitments',
  'ChangeCareStatus' = '/integration/lina/commitments/status',
  'PostFakeDoorInsights' = '/integration/lina/fakedoor/insights',
}

export interface ICareListResponse {
  total: number
  today?: ICareItem[]
  upcoming?: ICareItem[]
  later?: ICareItem[]
}
export interface ICareItemProfessional {
  id: string
  name: string
  specialtyId: string
  specialtyName: string
  photo?: string | null
  councilType: string
  professionalTypeId: string
}

export interface ICareSuggestionProfessional {
  id?: string | null
  name?: string | null
  specialtyId: string
  specialtyName: string
  photo?: string | null
  councilType: string
  professionalTypeId: string
}

export interface ICareItem {
  type: ICareType
  status: ICareStatus
  title: string
  id: string
  frequencyTime?: 'day' | 'month' | 'year' | null
  frequencyValue?: number | null
  appointment?: {
    id: string
    attendanceToken: string
    professional: ICareItemProfessional
    startDate?: string | null
    metadata?: UpcomingConsultationData
    appointmentSuggestion?: {
      fromProfessionalName: string
      professional?: ICareSuggestionProfessional | null
    } | null
  } | null
  exam?: {
    canSchedule: boolean
    details?: string | null
    originAppointment?: {
      id: string
      professional: ICareItemProfessional
      startDate?: string | null
    } | null
  } | null
  forwarding?: {
    id: string
    startDate?: string | null
    appointmentSuggestion?: {
      fromProfessionalName: string
      professional?: ICareSuggestionProfessional | null
    } | null
  } | null
  statusTimeInDays?: number | null
}

export enum ICareType {
  APPOINTMENT = 'APPOINTMENT',
  EXAM = 'EXAM',
  FORWARDING = 'FORWARDING',
}

export enum ICareTypeTranslation {
  APPOINTMENT = 'Consulta',
  EXAM = 'Exame',
  FORWARDING = 'Encaminhamento',
}

export type ICareTab = 'upcoming' | 'done'

export enum ICareStatus {
  ORDERED = 'ORDERED',
  SCHEDULED = 'SCHEDULED',
  CONFIRMED = 'CONFIRMED',
  TO_REALIZE = 'TO_REALIZE',
  NOT_SCHEDULED = 'NOT_SCHEDULED',
  LATE = 'LATE',
  REALIZED = 'REALIZED',
  RESULT_DONE = 'RESULT_DONE',
  CONCLUDED = 'CONCLUDED',
  PAUSED = 'PAUSED',
  CANCELLED = 'CANCELLED',
}

export enum ICareStatusTranslation {
  ORDERED = 'Pedido feito',
  SCHEDULED = 'Agendado',
  CONFIRMED = 'Confirmado',
  TO_REALIZE = 'A realizar',
  NOT_SCHEDULED = 'Não agendado',
  LATE = 'Em atraso',
  REALIZED = 'Realizado',
  RESULT_DONE = 'Resultado em mãos',
  CONCLUDED = 'Concluído',
  PAUSED = 'Pausado',
  CANCELLED = 'Cancelado',
}

export const statusTagMap: Record<ICareStatus, ITagKeys> = {
  [ICareStatus.TO_REALIZE]: 'information',
  [ICareStatus.REALIZED]: 'success',
  [ICareStatus.LATE]: 'warning',
  [ICareStatus.ORDERED]: 'primary',
  [ICareStatus.NOT_SCHEDULED]: 'warning',
  [ICareStatus.SCHEDULED]: 'primary',
  [ICareStatus.CONFIRMED]: 'success',
  [ICareStatus.CONCLUDED]: 'success',
  [ICareStatus.RESULT_DONE]: 'success',
  [ICareStatus.CANCELLED]: 'error',
  [ICareStatus.PAUSED]: 'neutral',
}

export interface ICareFilters {
  status: { label: ICareStatusTranslation; value: ICareStatus }[]
  type: { label: ICareTypeTranslation; value: ICareType }[]
  search: string
  tab: ICareTab
}

export type CareStatusFilterOption = {
  label: ICareStatusTranslation
  value: ICareStatus
}

export enum HealthCareStatus {
  NONE_CREATED = 'NONE_CREATED',
  CARE_LINE_CREATED = 'CARE_LINE_CREATED',
  CARE_LINE_AND_COMMITMENTS_CREATED = 'CARE_LINE_AND_COMMITMENTS_CREATED',
  UNAVAILABLE = 'UNAVAILABLE',
  PENDING = 'PENDING',
}

export interface IHealthCareStatus {
  status: HealthCareStatus
}
